import { ethers } from "ethers";
import { createContext, useContext, useLayoutEffect, useState } from "react";
import { contractAddress } from "../assets/address";
import lotteryABI from "../assets/abi.json";

const ContractContext = createContext({
  poolSize: 0,
  endTime: 0,
  getContractInfo: async () => null,
});
export const useContractContext = () => useContext(ContractContext);

export const ContractContextProvider = ({ children }) => {
  const [state, setState] = useState({
    poolSize: 0,
    endTime: 0,
  });
  const getContractInfo = async () => {
    try {
      const provider = new ethers.providers.JsonRpcProvider(
        "https://bsc.meowrpc.com"
      );
      const contract = new ethers.Contract(
        contractAddress,
        lotteryABI,
        provider
      );

      const poolSizePromise = contract.poolBalance();
      const endTimePromise = contract.lotteryEndTime();

      const [poolSize, endTime] = await Promise.all([
        poolSizePromise,
        endTimePromise,
      ]);
      setState({
        poolSize: poolSize.toString(),
        endTime: endTime.toString(),
      });
    } catch (err) {
      console.log({ err });
    }
  };

  useLayoutEffect(() => {
    getContractInfo();
  }, []);
  return (
    <ContractContext.Provider
      value={{
        ...state,
        getContractInfo,
      }}
    >
      {children}
    </ContractContext.Provider>
  );
};
